/**
 * @generated SignedSource<<d8113231d9a1c1752a7b67b91788bbe3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddressSelector_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AddressForm_viewer">;
  readonly " $fragmentType": "AddressSelector_viewer";
};
export type AddressSelector_viewer$key = {
  readonly " $data"?: AddressSelector_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddressSelector_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddressSelector_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddressForm_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "754dc198e10446ac4816edc8a9a4cde3";

export default node;
